import { 
  collection, getDocs, doc, updateDoc, setDoc, getDoc, deleteDoc, query, limit 
} from 'firebase/firestore';
import { 
  signInWithEmailAndPassword, signOut, GoogleAuthProvider, signInWithPopup, onAuthStateChanged 
} from 'firebase/auth';
import { db, auth } from './firebase';

const waitForAuth = () => {
  return new Promise((resolve) => {
    if (auth.currentUser) return resolve(auth.currentUser);
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
    setTimeout(() => {
      unsubscribe();
      resolve(auth.currentUser);
    }, 5000);
  });
};

export const apiService = {
  async loginWithGoogle() {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    const result = await signInWithPopup(auth, provider);
    return result.user;
  },

  async logout() {
    await signOut(auth);
  },

  async getLinks() {
    try {
      const querySnapshot = await getDocs(collection(db, 'links'));
      return querySnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    } catch (error) {
      console.error('Links Fetch Error:', error);
      return [];
    }
  },

  async getSettings() {
    try {
      const settingsRef = doc(db, 'settings', 'site_settings');
      const docSnap = await getDoc(settingsRef);
      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      }
      const q = query(collection(db, 'settings'), limit(1));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const firstDoc = querySnapshot.docs[0];
        return { id: firstDoc.id, ...firstDoc.data() };
      }
      return null;
    } catch (error) {
      console.error('Settings Fetch Error:', error);
      return null;
    }
  },

  async seedDatabase(links, settings) {
    const user = await waitForAuth();
    if (!user) throw new Error('Auth required');
    try {
      const settingsRef = doc(db, 'settings', 'site_settings');
      const cleanSettings = JSON.parse(JSON.stringify(settings));
      delete cleanSettings.id;
      await setDoc(settingsRef, cleanSettings);

      const existingSnap = await getDocs(collection(db, 'links'));
      for (const d of existingSnap.docs) {
        await deleteDoc(doc(db, 'links', d.id));
      }

      for (const link of links) {
        const id = link.id.toString();
        const cleanLink = {
          title: link.title,
          description: link.description,
          url: link.url,
          imageUrl: link.imageUrl,
          isComingSoon: !!link.isComingSoon
        };
        await setDoc(doc(db, 'links', id), cleanLink);
      }
      return true;
    } catch (error) {
      console.error('Seed Error:', error);
      throw error;
    }
  },

  async updateLink(id, data) {
    const ref = doc(db, 'links', id);
    const clean = JSON.parse(JSON.stringify(data));
    delete clean.id;
    await updateDoc(ref, clean);
  },

  async updateSettings(id, data) {
    const ref = doc(db, 'settings', 'site_settings');
    const clean = JSON.parse(JSON.stringify(data));
    delete clean.id;
    await setDoc(ref, clean);
  }
};